import { css } from 'styled-components'
import { breakpoints, contentWidth } from './tokens'

/**
 * The shared horizontal geometry for every top-level surface — the member and
 * public navbar rows, the breadcrumb trail, and the trip/overview page
 * containers — so their left and right edges line up on desktop. Centers a
 * `contentWidth` column with 36px side gutters (18px once the bento grid
 * collapses). Vertical padding stays per-surface: on the chrome, the full-bleed
 * outer element owns it; this mixin only sets the column and its gutters. Kept
 * here as the single source so the chrome can never drift from the content
 * column again (the mismatch this replaced was a 1200px navbar over a 1400px
 * page).
 */
export const contentShell = css`
	max-width: ${contentWidth};
	margin-left: auto;
	margin-right: auto;
	padding-left: 36px;
	padding-right: 36px;

	@media (max-width: ${breakpoints.bentoCollapse}px) {
		padding-left: 18px;
		padding-right: 18px;
	}
`
